export default __webpack_public_path__ + "8de4526c5108ad0bb04b5cc6bc0b69ba.png";